import { useMutation, type UseMutationOptions } from "@tanstack/react-query";
import {
  portalInvitationsApi,
  type InviteOrNotifyResult,
} from "@/api/collectionPackages";
import type { MaterialAudience } from "@/api/collectionTemplates";

// External Intake & Collection v1.0 PR 8 (Series 1) — single seam that
// dispatches the invitation for any CollectionPackage. Invite-system
// consolidation: the server issues a set-password invite for a
// not-yet-activated account and a "new request waiting" login
// notification for an activated one (result.mode tells which).
// Tier 2 #9 — first-time issues take the account type; re-issues
// against an already-linked account pass `undefined` (the server reads
// the type off the existing PortalUser).

export interface IssueInvitationInput {
  packageId: string;
  accountType?: MaterialAudience;
}

export type UsePortalInvitationOptions = Omit<
  UseMutationOptions<InviteOrNotifyResult, Error, IssueInvitationInput>,
  "mutationFn"
>;

export function usePortalInvitation(opts?: UsePortalInvitationOptions) {
  return useMutation<InviteOrNotifyResult, Error, IssueInvitationInput>({
    mutationFn: ({ packageId, accountType }) =>
      portalInvitationsApi.issue(packageId, accountType),
    ...opts,
  });
}
